<template>
  <div class="grid mr-2" v-if="notice">
    <div class="col-12 important-notice ml-2" style="background-color: white">
      <div>
        <h5 style="font-weight: bold; color: red; font-size: 1.2em">
          <i class="pi pi-info-circle"></i> Important Notice!
        </h5>
        <div style="font-size: 1.1em" v-html="notice"></div>
      </div>
    </div>
  </div>
  <div class="card flex flex-wrap">
    <div class="mr-3">
      <label for="StartDate" class="col-4">Start Date</label>
      <DatePicker
        v-model="StartDate"
        dateFormat="dd/mm/yyyy"
        inputMask="99/99/9999"
        momentFormat="DD/MM/YYYY"
        class="p-inputtext-sm"
      />
    </div>
    <div class="mr-3">
      <label for="EndDate" class="col-4">End Date</label>
      <DatePicker
        v-model="EndDate"
        dateFormat="dd/mm/yyyy"
        inputMask="99/99/9999"
        momentFormat="DD/MM/YYYY"
        class="p-inputtext-sm"
      />
    </div>
    <div class="mr-3">
      <Button
        label="Filter"
        class="p-button mr-2"
        @click="filterDashboard($event)"
        :disabled="this.blocked"
      />
    </div>
  </div>
  <BlockUI :blocked="this.blocked">
    <div class="grid">
      <div class="col-6">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total Work</span>
              <div class="text-900 font-medium text-xl">
                {{ this.workTotal }}
              </div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-briefcase text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.workSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.workAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-6">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total Permit</span>
              <div class="text-900 font-medium text-xl">{{ permitTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-slack text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.permitSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.permitAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total HOWP</span>
              <div class="text-900 font-medium text-xl">{{ howpTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.howpSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.howpAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total COWP</span>
              <div class="text-900 font-medium text-xl">{{ cowpTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.cowpSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.cowpAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total WAHP</span>
              <div class="text-900 font-medium text-xl">{{ wahpTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.wahpSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.wahpAvg }}</div>
          </div>
        </div>
      </div>

      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total CSEP</span>
              <div class="text-900 font-medium text-xl">{{ csepTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.csepSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.csepAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total LOTO</span>
              <div class="text-900 font-medium text-xl">{{ lotoTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.lotoSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.lotoAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total EXCP</span>
              <div class="text-900 font-medium text-xl">{{ excpTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.excpSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.excpAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total HLWP</span>
              <div class="text-900 font-medium text-xl">{{ hlwpTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.hlwpSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.hlwpAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-3">
        <div class="card mb-2">
          <div class="flex justify-content-between">
            <div>
              <span class="block text-500 font-medium">Grand Total LIVE</span>
              <div class="text-900 font-medium text-xl">{{ liveTotal }}</div>
            </div>
            <div
              class="flex align-items-center justify-content-center bg-blue-100 border-round"
              style="width: 2.5rem; height: 2.5rem"
            >
              <i class="pi pi-th-large text-blue-500 text-xl"></i>
            </div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Sum</span>
            <div class="text-900 font-medium text-xl">{{ this.liveSum }}</div>
          </div>
          <div class="flex justify-content-between mt-3">
            <span class="block text-500 font-medium">Average</span>
            <div class="text-900 font-medium text-xl">{{ this.liveAvg }}</div>
          </div>
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <h5>Grand Total Work Created - {{ this.daysRange }} days</h5>
          <Chart
            type="bar"
            :data="workData"
            :options="basicOptions2"
            height="100"
          />
        </div>
      </div>
      <div class="col-12">
        <div class="card">
          <h5>Grand Total Permit Date - {{ this.daysRange }} days</h5>
          <Chart
            type="bar"
            :data="permitData"
            :options="basicOptions"
            height="100"
          />
        </div>
      </div>
    </div>
  </BlockUI>
</template>

<script>
import moment from "moment";
export default {
  name: "Dashboard",
  props: {
    msg: String,
  },
  data() {
    return {
      StartDate: this.getDefaultStartDate(),
      EndDate: this.getTodayDate(),
      formEditable: true,
      companyCodeUser: this.$store.getters.getCompanyCode,
      companyIdUser: this.$store.getters.getCompanyId,
      idUser: this.$store.getters.getUserId,
      userName: this.$store.getters.getUsername,
      workTotal: 0,
      workSum: 0,
      workAvg: 0,
      permitTotal: 0,
      permitSum: 0,
      permitAvg: 0,
      howpTotal: 0,
      howpSum: 0,
      howpAvg: 0,
      cowpTotal: 0,
      cowpSum: 0,
      cowpAvg: 0,
      wahpTotal: 0,
      wahpSum: 0,
      wahpAvg: 0,
      csepTotal: 0,
      csepSum: 0,
      csepAvg: 0,
      lotoTotal: 0,
      lotoSum: 0,
      lotoAvg: 0,
      excpTotal: 0,
      excpSum: 0,
      excpAvg: 0,
      hlwpTotal: 0,
      hlwpSum: 0,
      hlwpAvg: 0,
      liveTotal: 0,
      liveSum: 0,
      liveAvg: 0,
      blocked: false,
      permitData: null,
      workData: null,
      dataUrl: "dashboard/",

      // basicData: {
      //     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
      //     datasets: [
      //         {
      //             label: 'My First dataset',
      //             backgroundColor: '#42A5F5',
      //             data: [65, 59, 80, 81, 56, 55, 40]
      //         },
      //         {
      //             label: 'My Second dataset',
      //             backgroundColor: '#FFA726',
      //             data: [28, 48, 40, 19, 86, 27, 90]
      //         }
      //     ]
      // },
      basicOptions: {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            min: 0, // Set nilai minimum sumbu Y
            max: 1200, // Set nilai maksimum sumbu Y
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      },
      basicOptions2: {
        plugins: {
          legend: {
            labels: {
              color: "#495057",
            },
          },
        },
        scales: {
          x: {
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
          y: {
            min: 0, // Set nilai minimum sumbu Y
            max: 50, // Set nilai maksimum sumbu Y
            ticks: {
              color: "#495057",
            },
            grid: {
              color: "#ebedef",
            },
          },
        },
      },
      noticeUrl: "util/important_notice",
      notice: "",
    };
  },
  methods: {
    showToast(message) {
      this.$toast.add({
        severity: "error",
        summary: "Error",
        detail: message,
        life: 3000,
      });
    },
    filterDashboard(event) {
      if (!this.StartDate) {
        this.showToast("Please Set Start Date Filter");
      }

      if (!this.EndDate) {
        this.showToast("Please Set End Date Filter");
      }

      if (this.StartDate && this.EndDate) {
        const start = new Date(this.StartDate);
        const end = new Date(this.EndDate);
        if (start > end) {
          this.showToast("Start Date cannot be greater than End Date");
        } else {
          const timeDiff = end - start;
          const dayDiff = timeDiff / (1000 * 60 * 60 * 24);

          if (dayDiff > 90) {
            this.showToast("The date range cannot exceed 3 months.");
          } else {
            this.getStatusCount();
            this.getDataPermitChart();
            this.getDataWorkChart();
            this.$emit("unblock-ui");
          }
        }
      }
    },
    getDataPermitChart() {
      var self = this;

      this.$axios
        .post(this.$API_URL + this.dataUrl + "permit_chart", {
          StartDate: moment(this.StartDate).format("YYYY-MM-DD").toString(),
          EndDate: moment(this.EndDate).format("YYYY-MM-DD").toString(),
          CompanyCode: this.companyCodeUser,
          DifferenceInDays: this.calculateDateDifference(),
        })
        .then((response) => {
          if (response && response.data.success) {
            self.permitData = response.data.data;
          }
        })
        .catch(function (err) {
          console.log(err);
          self.blocked = false;
        });
    },
    getDataWorkChart() {
      var self = this;

      this.$axios
        .post(this.$API_URL + this.dataUrl + "work_chart", {
          StartDate: moment(this.StartDate).format("YYYY-MM-DD").toString(),
          EndDate: moment(this.EndDate).format("YYYY-MM-DD").toString(),
          CompanyCode: this.companyCodeUser,
          DifferenceInDays: this.calculateDateDifference(),
        })
        .then((response) => {
          if (response && response.data.success) {
            self.workData = response.data.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getStatusCount() {
      var self = this;
      this.blocked = true;
      this.$axios
        .post(this.$API_URL + this.dataUrl + "status_count", {
          StartDate: moment(this.StartDate).format("YYYY-MM-DD").toString(),
          EndDate: moment(this.EndDate).format("YYYY-MM-DD").toString(),
          CompanyCode: this.companyCodeUser,
          DifferenceInDays: this.calculateDateDifference(),
        })
        .then((response) => {
          if (response && response.data.success) {
            var d = response.data.data;
            self.workTotal = d.workTotal;
            self.workSum = d.workSum;
            self.workAvg = d.workAvg;
            self.permitTotal = d.permitTotal;
            self.permitSum = d.permitSum;
            self.permitAvg = d.permitAvg;
            self.howpTotal = d.howpTotal;
            self.howpSum = d.howpSum;
            self.howpAvg = d.howpAvg;
            self.cowpTotal = d.cowpTotal;
            self.cowpSum = d.cowpSum;
            self.cowpAvg = d.cowpAvg;
            self.wahpTotal = d.wahpTotal;
            self.wahpSum = d.wahpSum;
            self.wahpAvg = d.wahpAvg;
            self.csepTotal = d.csepTotal;
            self.csepSum = d.csepSum;
            self.csepAvg = d.csepAvg;
            self.lotoTotal = d.lotoTotal;
            self.lotoSum = d.lotoSum;
            self.lotoAvg = d.lotoAvg;
            self.excpTotal = d.excpTotal;
            self.excpSum = d.excpSum;
            self.excpAvg = d.excpAvg;
            self.hlwpTotal = d.hlwpTotal;
            self.hlwpSum = d.hlwpSum;
            self.hlwpAvg = d.hlwpAvg;
            self.liveTotal = d.liveTotal;
            self.liveSum = d.liveSum;
            self.liveAvg = d.liveAvg;
            self.blocked = false;
          }
        })
        .catch(function (err) {
          console.log(err);
          self.blocked = false;
        });
    },
    getImportantNotice() {
      var self = this;

      this.$axios
        .get(this.$API_URL + this.noticeUrl)
        .then((response) => {
          if (response.data.success) {
            self.notice = response.data.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    getTodayDate() {
      const today = new Date();
      const test = moment(today).format("YYYY-MM-DD").toString();
      return test;
    },
    getDefaultStartDate() {
      const today = new Date();
      const startDates = new Date(today);
      startDates.setDate(today.getDate() - 6);
      const test = moment(startDates).format("YYYY-MM-DD").toString();
      return test;
    },
    calculateDateDifference() {
      if (this.StartDate && this.EndDate) {
        const startDate = new Date(this.StartDate);
        const endDate = new Date(this.EndDate);
        const timeDifference = endDate - startDate;
        const differenceInDays = timeDifference / (1000 * 3600 * 24); // Convert from milliseconds to days
        this.daysRange = Math.floor(differenceInDays) + 1;
        return this.daysRange;
      }
    },
  },
  mounted() {
    if (!this.$store.getters.isAuthenticated) {
      this.$router.push({ name: "Login", params: { sessionExpired: true } });
    }

    this.getDataPermitChart();
    this.getDataWorkChart();
    this.getStatusCount();
    this.getImportantNotice();
  },
  computed: {
    showDashboard() {
      return this.$store.getters.getIsUser;
    },
    showOrder() {
      return (
        this.$store.getters.getIsAdmin ||
        (this.$store.getters.getIsUser &&
          this.$store.getters.getDepartment != this.$DEPARTMENTS.WAREHOUSE)
      );
    },
    showSAPOrder() {
      return (
        this.$store.getters.getIsAdmin ||
        (this.$store.getters.getIsUser &&
          this.$store.getters.getDepartment != this.$DEPARTMENTS.WAREHOUSE)
      );
    },
    showShipment() {
      return this.$store.getters.getIsUser;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.important-notice {
  border: 2px dashed red;
}
</style>
